module.exports = __webpack_public_path__ + "img/keine kamishirasawa_lw.2bbd2dd1.png";